<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="10" cy="10" r="7.25" stroke="currentColor" stroke-width="1.5" />
    <circle cx="10" cy="10" r="4" fill="currentColor" />
  </svg>
</template>
<style lang="scss" scoped>
svg {
  flex-shrink: 0;
}
</style>
